import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { EquipmentService } from "src/app/equipment/equipment.service";
import { Equipment, EquipmentsEntity } from "src/app/equipment/equipment";
import { MatSnackBar } from "@angular/material";
import { AuthService } from "src/app/auth.service";

@Component({
  selector: "app-equipment",
  templateUrl: "./equipment.component.html",
  styleUrls: ["./equipment.component.css"],
})
export class EquipmentComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = true;

  constructor(
    private equipmentService: EquipmentService,
    private snackBar: MatSnackBar,
    public auth: AuthService
  ) {}

  searchEquipment: string | number | any | null;
  equipments: EquipmentsEntity[];

  ngOnInit() {
    this.auth.userProfileSubject$.subscribe(
      (profile) => {
        if (profile) {
          this.getEquipmentList();
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackBar.open(
          `Error in Getting Designer and Contractor Details`,
          "",
          {
            duration: 2000,
          }
        );
      }
    );
  }

  /**
   * Get Equipments List
   */
  getEquipmentList() {
    this.showLoader = true;
    this.subscription$.add(
      this.equipmentService.getEquipmentList().subscribe(
        (result: Equipment) => {
          this.equipments = result.equipments;
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Equipment List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

/**
 * unsubscribe the subscriptions
 */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
